module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Flat Silver White Nike Open.1f583779.png";